import { Trans } from "@lingui/macro";
import { Link } from "react-router-dom";

export default function PermissionDenied() {
  return (
    <div className="grid gap-4 justify-content-center justify-items-center content-center">
      <h1 className="text-5xl font-bold -mb-2">Permission Denied</h1>
      <p className="text-xl">
        <Trans>The document is owned by another user, and they have not given you permission to access it.</Trans>
      </p>
      <Link to="/" className="text-blue-500 hover:underline">
        <Trans>Go back home</Trans>
      </Link>
    </div>
  );
}
